var render, staticRenderFns
import script from "./documentBaseLogic.vue?vue&type=script&lang=js&"
export * from "./documentBaseLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edfe552",
  null
  
)

export default component.exports